import { Button, Typography } from '@navi/web-ui/lib/primitives';
import { UseFormGetValues } from 'react-hook-form';
import GreenCheckIcon from '@cp/src/assets/images/icons/GreenCheckIcon';
import WarningSection from './WarningSection';
import AnimatedLoading from './AnimatedLoading';
import { VERIFICATION_MESSAGE, VERIFICATION_STATUS } from '../../constants/constants';
import { AgentFormValues } from '../../interfaces/types';

interface IVerificationComponentProps {
  getValues: UseFormGetValues<AgentFormValues>;
  locationVerificationStatus: string;
  showLocationVerificationToast: boolean;
  isEditDisabled: boolean | undefined;
  reverseGeocodedAgentCity: string;
  reverseGeocodedAgentPincode: string;
  handleVerification: () => Promise<void>;
  showVerifyButton: boolean;
  showCityPincode: boolean;
  isMisMatchedState: boolean;
  warningMessage: string;
}
const VerificationComponent = (props: IVerificationComponentProps) => {
  const {
    getValues,
    locationVerificationStatus,
    showLocationVerificationToast,
    isEditDisabled,
    reverseGeocodedAgentCity,
    reverseGeocodedAgentPincode,
    handleVerification,
    showVerifyButton,
    showCityPincode,
    isMisMatchedState,
    warningMessage
  } = props;

  const isReverseGeocodedCityPincodeVisible =
    showCityPincode &&
    reverseGeocodedAgentCity &&
    reverseGeocodedAgentPincode &&
    reverseGeocodedAgentCity?.length > 0 &&
    reverseGeocodedAgentPincode?.length > 0;
  return (
    <div className="flex-1">
      <div>
        {!isEditDisabled ? (
          !(locationVerificationStatus === VERIFICATION_STATUS.IN_PROGRESS) ? (
            <Button
              size="small"
              onClick={() => {
                handleVerification();
              }}
              variant="text"
              className="pl-5"
              type="button"
              disabled={
                !showVerifyButton ||
                !(getValues('nextMonthLatitude') && getValues('nextMonthLongitude'))
              }
            >
              Verify
            </Button>
          ) : (
            <AnimatedLoading color={'var(--navi-color-gray-c3)'} />
          )
        ) : null}
      </div>

      {showLocationVerificationToast &&
        locationVerificationStatus === VERIFICATION_STATUS.UNVERIFIED && (
          <WarningSection
            message={VERIFICATION_MESSAGE.UNVERIFIED_LOCATION}
            color={'var(--orange-darkbase)'}
            iconColor={'var(--orange-darkbase)'}
            bgColor={'var(--orange-oldlase)'}
          />
        )}

      {showLocationVerificationToast &&
        locationVerificationStatus === VERIFICATION_STATUS.IN_PROGRESS && (
          <WarningSection
            message={VERIFICATION_MESSAGE.VERIFICATION_IN_PROGRESS}
            color={'var(--orange-darkbase)'}
            iconColor={'var(--orange-darkbase)'}
            bgColor={'var(--orange-oldlase)'}
          />
        )}

      {isReverseGeocodedCityPincodeVisible && (
        <div className="flex-1 mt-1">
          <div className="flex pl-5">
            <Typography variant={'h5'} color="var(--navi-color-gray-c3)" className="pr-1">
              Pincode:
            </Typography>
            <Typography variant={'h5'} color="var(--navi-color-gray-c2)" className="pr-4">
              {reverseGeocodedAgentPincode}
            </Typography>
            <Typography variant={'h5'} color="var(--navi-color-gray-c3)" className="pr-1">
              City:
            </Typography>
            <Typography variant={'h5'} color="var(--navi-color-gray-c2)" className="pr-4">
              {reverseGeocodedAgentCity}
            </Typography>
            {showVerifyButton && locationVerificationStatus === VERIFICATION_STATUS.VERIFIED && (
              <>
                <GreenCheckIcon />
                <Typography variant={'h5'} color="var(--green-base)" className="pl-1">
                  {`Verified`}
                </Typography>
              </>
            )}
          </div>

          {isMisMatchedState && (
            <WarningSection
              message={warningMessage}
              color={'var(--grayscale-2)'}
              iconColor={'var(--grayscale-2)'}
              showTriangle={false}
              bgColor="var(--blue-bg)"
            />
          )}
        </div>
      )}
    </div>
  );
};

export default VerificationComponent;
